export default {
  appsignal: {
    apiKey: process.env.APPSIGNAL_FRONTEND_API_KEY,
  },
  environment: process.env.HANAMI_ENV,
  revision: process.env.GIT_REV,
};
